module.exports = __webpack_public_path__ + "img/icon-logout.7297b68c.svg";